import React from 'react';
import { connect } from 'react-redux'
import * as queryString from 'query-string';
import { firstNameFirst, getFirstName } from "../../helpers/formatting";
import YesNoModal from "../common/YesNoComponent";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { Tooltip } from 'reactstrap';
import { Button } from '../ecosystem/';

class SelectPatient extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showModal: false, modalText: null, modalYesFunction: null, modalNoFunction: null, showToolTip: false };
        this.userSelected = props.userSelected;
    }

    componentDidUpdate(prevProps) {

        const { location, byPassProxyAndInfo, goNext,goToNewStep, isNonProxyUser,isFromDotCOM, skipPatientInfo, enableNewServiceSchedulingWorkflow, isMammography } = this.props;
        const params = location && location.search ? queryString.parse(location.search) : {};
        const { s } = params;
        if (prevProps !== this.props && byPassProxyAndInfo && s && s == 1 && isMammography) {
            //updateBypassProxyAndInfo(false);      
            if(this.props.reasonSubmitStepValue) {
                goToNewStep(true, this.props.reasonSubmitStepValue); 
            }
            //else{
               // goNext();
           //}
        }

        // when using "Back to Calender" option , skip this Screen
        if (isMammography && skipPatientInfo && s && s == 1 && !isNonProxyUser) {
            this.props.backToCalender(false);
            this.props.goToNewStep(true, 2)
        }
    }

    isValid() {
        return this.userSelected !== null;
    }

    cancelModal() {
        this.setState({ showModal: false });
    }

    onUserSelected(event, user, index) {
        event.preventDefault();
        const { currentUser } = this.props;
        //debugger;
        if (user.externalId !== currentUser.externalId || user.externalId !== currentUser.externalId) {
            this.setState({
                showModal: true,
                modalText: "Are you sure you want to switch to " + getFirstName(user.displayName) + "'s Account?",
                modalYesFunction: () => {
                    this.switchToUser(user, index);
                    if (this.props.onUserSelected) {
                        this.props.onUserSelected(user);
                    }
                },
                modalNoFunction: () => this.cancelModal()
            });
        }
        else {
            this.userSelected = user;
            if (this.props.loadEVisitPage) {
                this.props.loadEVisitPage(true);
            }
            //debugger;
            // only switch if the user is different, which should be never
            if (user.externalId !== currentUser.externalId || user.externalId !== currentUser.externalId) {
                this.switchToUser(user, index);
            }

            //if user comes from .COM skip preselected steps.
            if (this.props.enableNewProviderSchedulingWorkflow && this.props.isFromDotCOM && !this.props.apptSlotNotAvailable && !this.props.apptTimeNotAvailable && this.props.reasonSubmitStepValue && this.props.hasMychart) {
                this.props.goToNewStep(true, this.props.reasonSubmitStepValue);
            } else if (this.props.enableNewServiceSchedulingWorkflow && this.props.isFromDotCOM && this.props.reasonSubmitStepValue){
                this.props.goToNewStep(true, this.props.reasonSubmitStepValue);
            }
            else if (this.props.goToApptInfo && this.props.apptInfoStepValue) {
                if (this.props.steptitle && this.props.goToNewStep) {
                    this.props.goToNewStep(true, this.props.apptInfoStepValue);
                }
            } else {
                if (this.props.steptitle && this.props.goNext) {
                    this.props.goNext();
                }
            }


            if (this.props.onUserSelected) {
                this.props.onUserSelected(user);
            }
        }

        if (index === 0 && this.props.onClicked)
            this.props.onClicked();
    }

    switchToUser(user, index) {
        this.userSelected = user;
        if (this.props.isMammography) {
            this.props.newUserSelected(true);
        }
        if (this.props.switchToMyChartUser) {
            this.props.switchToMyChartUser(user, index);
        }

        if (this.props.loadEVisitPage) {
            this.props.loadEVisitPage(true);
        }
        this.cancelModal();
        if (this.props.enableNewProviderSchedulingWorkflow && this.props.isFromDotCOM && !this.props.apptSlotNotAvailable && !this.props.apptTimeNotAvailable && this.props.reasonSubmitStepValue && this.props.hasMychart) {
            this.props.goToNewStep(true, this.props.reasonSubmitStepValue);
        } else if (this.props.enableNewServiceSchedulingWorkflow && this.props.isFromDotCOM && this.props.reasonSubmitStepValue){
            this.props.goToNewStep(true, this.props.reasonSubmitStepValue);
        }
        else if (this.props.goToApptInfo && this.props.apptInfoStepValue) {
            if (this.props.steptitle && this.props.goToNewStep) {
                this.props.goToNewStep(true, this.props.apptInfoStepValue);
            }
        } else {
            if (this.props.steptitle && this.props.goNext) {
                this.props.goNext();
            }
        }
    }

    toggleTooltip = () => {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }

    isButtonDisabled = (isMammography, user, showPatientButtonDisabledBlurb) => {
        return (isMammography && ((showPatientButtonDisabledBlurb &&
            (user.GenderIdentity).toLowerCase() == 'male')
            || ((user.GenderIdentity).toLowerCase() == 'female' && user.ageYears <= 35)))
    }

    render() {
        const { showModal, modalText, modalYesFunction, modalNoFunction, showToolTip } = this.state;
        const { myProxies, currentUser, message, loadEVisitPage, fromEvisit, iconLeftClass, removeActive, className, activityCode, hasMychart, isAdult, serverData, patientProfiles, isMammography } = this.props;
        const activeUser = !this.userSelected ? null : currentUser;
        const styleButton = (!this.props.fromEvisit);
        const containerClass = "select-patient-container" + (className ? " " + className : "");
        var showPatientButtonDisabledBlurb = false;
        const patientButtonDisabledIndividualMsg = "Why are some individuals not available for selection?";
        const patientButtonDisabledReason = "Currently we offer online scheduling for female patients ages 35 and older. We also offer alternative scheduling methods for individuals who do not identify as female. For further assistance please contact your primary care provider.";

        for (var i = 0; i < myProxies.length; i++) {
            myProxies[i].GenderIdentity = patientProfiles[i].patient.GenderIdentity;
            if (patientProfiles[i].patient && patientProfiles[i].patient.GenderIdentity && (((patientProfiles[i].patient.GenderIdentity).toLowerCase() === 'male') || ((patientProfiles[i].patient.GenderIdentity).toLowerCase() === 'female' && patientProfiles[i].patient.AgeYears <= 35)) && isMammography) {
                showPatientButtonDisabledBlurb = true;
            }
        }

        const iconStyle = {
            height: '24px',
            width: '24px',
            color: '#419BF9',
        };
        return (<div className={containerClass} style={this.props.style}>
            <YesNoModal showModal={showModal} modalText={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />
            <div className="row select-patient-section">
                <div className="col-12">
                    <div className={"select-patient-title"}>
                        <div className={iconLeftClass ? iconLeftClass : "svg-evisit"} />
                        <h1 className="step-heading">{message}</h1>
                    </div>
                    {showPatientButtonDisabledBlurb && (
                        <React.Fragment>
                            <div className="message text-center mb-4">
                                {patientButtonDisabledIndividualMsg} <span className="icon-question" id="lbl-proxy" style={iconStyle} />
                                <Tooltip className='notification-tool-tip' placement="top" isOpen={showToolTip} autohide={false} target="lbl-proxy" toggle={() => { this.toggleTooltip(); }}>
                                    {patientButtonDisabledReason}
                                </Tooltip>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className={`col-12 select-patient-list`}>
                    {myProxies && myProxies.length > 0 &&
                        myProxies.map((user, index) =>
                            <div className="form-group" key={index}>
                                <button className={`btn btn-primary ${activeUser && activeUser.externalId === user.externalId && styleButton && !removeActive ? 'active' : ''}  ${(isMammography && ((showPatientButtonDisabledBlurb && user.GenderIdentity && (user.GenderIdentity).toLowerCase() == 'male') || (user.GenderIdentity && (user.GenderIdentity).toLowerCase() == 'female' && user.ageYears <= 35))) ? 'disabled' : ''}`}
                                    onClick={(event) => this.onUserSelected(event, user, index)}
                                >
                                    {index === 0 ? "MYSELF" : firstNameFirst(user.displayName)}
                                </button>
                            </div>
                        )}
                    {currentUser && myProxies && myProxies.length > 1 && hasMychart && isAdult &&
                        <div className="form-group add-dependent">
                            We've created a new online process to add a dependent, making it easier and faster.
                            <div className="btn-dependent"><Link to={{ pathname: "/proxyrequestDOB", searchParams: "fromNoProxy=true" }} onClick={() => { if (activityCode) logUI(activityCode, new Date(), Tools.getURLPath()); }}><span className="icon-new" /> ADD A DEPENDENT</Link></div>
                        </div>}
                </div>
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => {
    return {
        byPassProxyAndInfo: state.openScheduling.byPassProxyAndInfo,
        patientProfiles: state.memberships.profileList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBypassProxyAndInfo: payload => dispatch({ type: types.UPDATE_BYPASS_PROXY_AND_INFO, payload })
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(SelectPatient);
